module.exports = __webpack_public_path__ + "static/media/sm.d69bce00.svg";